module.exports = __webpack_public_path__ + "static/img/logo.4a8052f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/logo.png
// module id = EDn9
// module chunks = 25